import React, { Fragment, useEffect, useState } from 'react';
import { Box, Grid, Drawer, IconButton, Tabs, Tab, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import _ from 'lodash';
import { FxIcon } from '../icon/FxIcon';
import { FxButton } from '../button/FxButton';
import { FxInput } from '../input/FxInput';
import { FxDate } from '../date/FxDate';
import { FxCheckbox } from '../checkbox/FxCheckbox';
import { FxSelect } from '../select/FxSelect';
import { FxPassword } from '../password/FxPassword';
import { FxTextArea } from '../textarea/FxTextarea';
import { getValue, setValue } from '../helpers';
export const FormComponent = (props: any) => {

    const { controls: controlList, handleInputChange, handleArrayInputChange,
        formModel, formModelId, lookup = {}, validationMap = {}, errors = {},
        onApplySettings, drawerStatus, handleDrawerStatusChange, id, layout, computeCallback, customRenderer,
        addItemToArray, deleteItemFromArray, processCascadingLookups } = props;

    const defaultControls: any = [];
    const [controls, setControls] = useState(defaultControls);
    const updateControls = (cntrls: any) => {
        setControls((prevState: any) => {
            return [...cntrls];
        })
    }

    useEffect(() => {
        prepareForm(controlList);
    }, [controlList])

    const computeItem = (item: any, options: any) => {
        if (item.controls) {
            for (let panelChild of item.controls) {
                panelChild["colSize"] = 12 / (item.layout ? item.layout : 1);
                panelChild.selected = panelChild.hasOwnProperty('selected') ? panelChild.selected : true;

                //Prepare formOptions
                prepareFormOptions(panelChild, options);

                if (panelChild.type == 'morepanel') {
                    if (panelChild.controls) {
                        for (let morePanelChild of panelChild.controls) {
                            morePanelChild.selected = morePanelChild.hasOwnProperty('selected') ? morePanelChild.selected : true;
                        }
                    }
                } else if (panelChild.type == 'cell') {
                    panelChild.rowStart = panelChild.position[0];
                    panelChild.columnStart = panelChild.position[1];
                    panelChild.columnSpan = panelChild.columnSpan || 1;
                    panelChild.columnEnd = "span " + panelChild.columnSpan;
                    panelChild.controlConfig.selected = panelChild.controlConfig.hasOwnProperty('selected') ? panelChild.controlConfig.selected : true;

                    //Prepare formOptions
                    prepareFormOptions(panelChild.controlConfig, options);
                }
                else if (item.type == "tabpanel" && (panelChild.type == 'panel' || panelChild.type == 'gridpanel')) {
                    computeItem(panelChild, options);
                }
            }
        }
    };

    const prepareForm = (latestControls: any) => {
        let formModel: any = {};
        let validationMap: any = {};
        let lookupKeys: any = {};
        let cascadingMap: any = {};

        if (latestControls) {
            let controlList = [];
            for (let control of latestControls) {
                let item = { ...control };
                if (item.type == 'panel' || item.type == 'gridpanel' || item.type == 'tabpanel') {
                    item["colSize"] = 12;
                } else {
                    item["colSize"] = 12 / (layout ? layout : 1);
                }
                item["expand"] = true;
                item.selected = item.hasOwnProperty('selected') ? item.selected : true;

                //Prepare formOptions
                prepareFormOptions(item, { formModel, validationMap, lookupKeys, cascadingMap });

                if (item.type == 'panel' || item.type == 'gridpanel' || item.type == 'morepanel' || item.type == 'tabpanel') {
                    computeItem(item, { formModel, validationMap, lookupKeys, cascadingMap });
                }
                controlList.push(item);
            }
            updateControls(controlList);

            //Send the options back to store
            if (computeCallback) {
                const formOptions: any = { formModel: formModel, validationMap: validationMap, lookupKeys, cascadingMap };
                console.log('formOptions=', formOptions);
                computeCallback(formOptions);
            }
        }
    }

    const prepareFormOptions = (item: any, options: any) => {
        const { formModel, validationMap, lookupKeys, cascadingMap } = options;
        let itemKey = item.model || item.path;
        if (itemKey) {
            let defaultValue = item.defaultValueExpression ? eval(item.defaultValueExpression) : item.defaultValue;
            setValue(formModel, itemKey, defaultValue || "");

            if (item.validations) {
                let validations = [...item.validations];
                if (item.type == "combo") {
                    validations = validations.map(function (x) { return x.replace(/required/g, "comboRequired") });
                }
                validationMap[itemKey] = validations;
            }
            if (item.type == "combo") {
                lookupKeys[item.lookupKey] = { "default": item.default || false };
                if (item.basedOn) {
                    if (!cascadingMap[item.basedOn]) {
                        cascadingMap[item.basedOn] = {};
                    }
                    cascadingMap[item.basedOn][item.model] = { lookupKey: item.lookupKey, model: item.model };
                }
            }
            if (item.type == "checkbox") {
                let defaultVal = item.hasOwnProperty("defaultValue") ? item.defaultValue : false;
                defaultVal = item.defaultValueExpression ? eval(item.defaultValueExpression) : defaultVal;
                setValue(formModel, itemKey, defaultVal);
            }
        }
        if (item.type == "custom") {
            let cutomItemKey = item.model || item.key;
            setValue(formModel, cutomItemKey, item.defaultModel);
        }
        //Common place compute disableExpression
        if (item.controlRule?.disableExpression) {
            item["disabled"] = eval(item.controlRule.disableExpression);
        }
    }

    const openMorePanel = (morePanel: any) => {
        let drawerStatusObj: any = {};
        drawerStatusObj[morePanel.key] = true;
        handleDrawerStatusChange(drawerStatusObj);
    }

    const closeMorePanel = (morePanel: any) => {
        let drawerStatusObj: any = {};
        drawerStatusObj[morePanel.key] = false;
        handleDrawerStatusChange(drawerStatusObj);
    }

    const renderText = (control: any, idx: any, id: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxInput
            name={controlKey}
            path={control.path}
            variant="outlined"
            textBoxLabel={control.label}
            disabled={control.disabled}
            fullWidth
            value={value}
            onValueChange={handleInputChange}
            validations={validations}
            validationResult={validationResult} />
    }

    const renderPassword = (control: any, idx: any, id: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxPassword
            name={controlKey}
            path={control.path}
            variant="outlined"
            textBoxLabel={control.label}
            disabled={control.disabled}
            fullWidth
            value={value}
            onValueChange={handleInputChange}
            validations={validations}
            validationResult={validationResult} />
    }

    const renderTextArea = (control: any, idx: any, id: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxTextArea
            name={controlKey}
            path={control.path}
            variant="outlined"
            textBoxLabel={control.label}
            disabled={control.disabled}
            fullWidth
            value={value}
            onValueChange={handleInputChange}
            validations={validations}
            validationResult={validationResult}
            minRows={4}
            maxRows={4}
        />
    }

    const handleComboChange = (item: any, controlKey: any) => {
        handleInputChange(item);
        //Load cascading lookup
        processCascadingLookups(controlKey);
    }

    const renderCombo = (control: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxSelect
            name={controlKey}
            path={control.path}
            textBoxLabel={control.label}
            disabled={control.disabled}
            options={lookup[control.lookupKey]}
            variant="outlined"
            valueField={control.valueField}
            displayField={control.displayField}
            selectedValue={value}
            onValueChange={(item) => handleComboChange(item, controlKey)}
            validations={validations}
            validationResult={validationResult} />
    }

    const renderDate = (control: any, idx: any, id: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxDate
            name={controlKey}
            path={control.path}
            placeholder={control.label}
            dateLabel={control.label}
            variant="outlined"
            value={value}
            onValueChange={handleInputChange}
            size="small"
            type="date"
            validations={validations}
            validationResult={validationResult}
        />
    }

    const renderCheckbox = (control: any, idx: any, id: any) => {
        let controlKey = control.model || control.path;
        let value = getValue(formModel, controlKey);
        let validations = getValue(validationMap, controlKey);
        let validationResult = getValue(errors, controlKey);

        return <FxCheckbox
            color="primary"
            name={controlKey}
            path={control.path}
            value={value}
            label={control.label}
            labelPlacement={control.labelPlacement}
            onValueChange={handleInputChange} />
    }

    const togglePanel = (panelControl: any, panelIdx: any) => {
        let currentControls: any = controls;
        panelControl.expand = !panelControl.expand;
        currentControls.splice(panelIdx, 1, panelControl);
        updateControls(currentControls);
    }

    const renderPanel = (panelControl: any, idx: any, id: any) => {
        let morePanels = panelControl.controls.filter((i: any) => i.type == "morepanel" && i.selected == true);
        morePanels = _.orderBy(morePanels, ['displayOrder'], ['asc']);

        return <>
            {!panelControl.hideHeader && <Grid item xs={12} className="form-panel-header" id={`${id}-header`}>
                <div className='header-div'>
                    {panelControl.label &&
                        <span>{panelControl.label}</span>
                    }
                    <div>
                        {morePanels && morePanels.map((morePanel: any, moreIdx: any) => (
                            <FxButton
                                key={moreIdx}
                                label={morePanel.label}
                                variant="contained"
                                color="inherit"
                                endIcon="fas fa-pencil-alt"
                                size="small"
                                className="m-right-2"
                                onClick={() => openMorePanel(morePanel)} />
                        ))}
                        <IconButton size="small" onClick={() => togglePanel(panelControl, idx)} id={`toggle-${id}`}>
                            {panelControl.expand ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                        </IconButton>
                    </div>
                </div>
            </Grid>}
            {panelControl.expand &&
                <Grid container id={id}>
                    {panelControl && panelControl.controls.map((control: any, idx: any) => (
                        <Fragment key={idx}>
                            {control.selected &&
                                <Grid item xs={control.colSize} id={id + '-cell-' + idx} style={{ padding: control.type == 'panel' || control.type == 'gridpanel' || control.type == 'tabpanel' ? 0 : '10px' }}>
                                    {renderComponent(control, idx, id)}
                                </Grid>
                            }
                        </Fragment>
                    ))}
                </Grid>
            }
        </>
    }

    const renderMorePanel = (panelControl: any, idx: any, id: any) => {
        return <Drawer anchor="right" className="more-panel-drawer" open={drawerStatus[panelControl.key]}
            onClose={() => closeMorePanel(panelControl)} id={`${id}-more-panel-${idx}`}>
            <Box>
                <Box sx={{
                    borderBottom: "1px solid gray", fontWeight: "bold",
                    fontSize: "14px", paddingTop: "8px", paddingBottom: "8px", paddingLeft: "10px"
                }}>
                    <span>{panelControl.label}</span>
                    <span className="float-right m-right-3 pointer" id={`${id}-close-${idx}`} onClick={() => closeMorePanel(panelControl)}>
                        <FxIcon icon="fas fa-times-circle" />
                    </span>
                </Box>
                <Box sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                    {panelControl && panelControl.controls.map((control: any, idx: any) => (
                        <div className='mt-2' key={idx}>
                            {control.selected && renderComponent(control, idx, id)}
                        </div>
                    ))}
                </Box>
            </Box>
        </Drawer>
    }

    const renderGridPanel = (gridPanelControl: any, idx: any, id: any) => {
        return <>
            <Grid item xs={12} className="form-panel-header" id={`${id}-header`}>
                <div className='header-div'>
                    {gridPanelControl.label &&
                        <span>{gridPanelControl.label}</span>
                    }
                    <div>
                        {gridPanelControl && gridPanelControl.controls.filter((i: any) => i.type == "morepanel").map((morePanel: any, moreIdx: any) => (
                            <FxButton
                                key={moreIdx}
                                label={morePanel.label}
                                variant="contained"
                                color="inherit"
                                endIcon="fas fa-pencil-alt"
                                size="small"
                                className="button-style"
                                onClick={() => openMorePanel(morePanel)} />
                        ))}
                        <IconButton size="small" onClick={() => togglePanel(gridPanelControl, idx)} id={`toggle-${id}`}>
                            {gridPanelControl.expand ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                        </IconButton>
                    </div>
                </div>
            </Grid>
            {
                gridPanelControl.expand &&
                <div className="d-grid" id={id}
                    style={{
                        gridTemplateRows: gridPanelControl.rows,
                        gridTemplateColumns: gridPanelControl.columns
                    }}
                >
                    {gridPanelControl && gridPanelControl.controls.map((cell: any, cellIdx: any) => (
                        <Fragment key={cellIdx}>
                            {cell.selected &&
                                <Grid item
                                    style={{
                                        gridRowStart: cell.rowStart,
                                        gridColumnStart: cell.columnStart,
                                        gridColumnEnd: cell.columnEnd,
                                    }}
                                >
                                    {cell.controlConfig.selected &&
                                        <>
                                            {renderComponent(cell.controlConfig, cellIdx, id)}
                                        </>
                                    }
                                </Grid>
                            }
                        </Fragment>
                    ))}
                </div>
            }
        </>
    }

    const [tabValue, setTabValue] = React.useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const renderTabPanel = (tabPanelControl: any, idx: any, id: any) => {
        interface TabPanelProps {
            children?: React.ReactNode;
            index: number;
            value: number;
            id: number;
        }

        function TabPanel(props: TabPanelProps) {
            const { children, value, index, id, ...other } = props;

            return (
                <div
                    role="tabpanel"
                    className='tabpanel'
                    hidden={value !== index}
                    id={`${id}-${index}`}
                    aria-labelledby={`${id}-${index}`}
                    {...other}
                >
                    {value === index && (
                        <Typography>{children}</Typography>
                    )}
                </div>
            );
        }

        function a11yProps(id: any, index: number) {
            return {
                id: `${id}-${index}`,
                'aria-controls': `${id}-${index}`,
            };
        }

        const getStyleForTabContainer = (tabPanelControl: any) => {
            let style: any = {};
            if (tabPanelControl.orientation == 'vertical') {
                style["flexGrow"] = 1;
                style["display"] = 'flex';
                style["height"] = '100%';
            }
            return style;
        }

        const getStyleForTabs = (orientation: any) => {
            let style: any = orientation == 'vertical' ? { borderRight: 1, borderColor: 'divider' } : { borderBottom: 1, borderColor: 'divider' };
            return style;
        }

        let tabControls = _.orderBy(tabPanelControl.controls, ['displayOrder'], ['asc']);
        tabControls = tabControls.filter(t => t.selected == true);

        return <Box className={tabPanelControl.orientation} id={id + '-' + tabPanelControl.orientation} sx={getStyleForTabContainer(tabPanelControl)}>
            <Tabs
                id={id}
                orientation={tabPanelControl.orientation}
                value={tabValue}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                onChange={handleTabChange}
                aria-label="Vertical tabs example"
                sx={getStyleForTabs(tabPanelControl.orientation)}
            >
                {tabControls.map((tab: any, tabIdx: any) => (
                    <Tab key={tabIdx} label={tab.label} {...a11yProps(id, tabIdx)} />
                ))}
            </Tabs>
            {tabControls.map((tabPanel: any, tabPanelIdx: any) => (
                <TabPanel key={tabPanelIdx} value={tabValue} index={tabPanelIdx} id={id}>
                    {renderComponent(tabPanel, tabPanelIdx, id)}
                </TabPanel>
            ))}
        </Box>
    }

    const controlMap: any = {
        text: renderText,
        password: renderPassword,
        textarea: renderTextArea,
        combo: renderCombo,
        date: renderDate,
        checkbox: renderCheckbox,
        panel: renderPanel,
        morepanel: renderMorePanel,
        gridpanel: renderGridPanel,
        tabpanel: renderTabPanel
    }

    const handleApplySettings = (popupState: any, data: any) => {
        console.log('handleApplySettings : data=', data);
        popupState.close();
        let inputData: any = JSON.parse(JSON.stringify(data));
        prepareForm(inputData.controls);
        if (onApplySettings) {
            onApplySettings(inputData);
        }
    }

    const handleCancelSettings = (popupState: any) => {
        popupState.close();
    }

    const getId = (control: any, idx: any, id: any) => {
        let key: any = control.type + '-' + id + '-' + idx;
        return key;
    }

    const renderComponent = (control: any, idx: any, id: any) => {
        let customId = getId(control, idx, id);
        if (controlMap[control.type]) {
            return controlMap[control.type](control, idx, customId);
        } else if (customRenderer) {
            let options = {
                control, idx, id: customId, formModel,
                handleInputChange, handleArrayInputChange, addItemToArray, deleteItemFromArray
            };
            return customRenderer(options);
        }
    }

    return (
        <div className='form-container' id={id}>
            <Grid className='form-controls' container id={`form-controls-${id}`}>
                {formModel && controls.map((control: any, idx: any) => (
                        <Fragment key={idx}>
                        {!control.canHide &&
                            <Grid key={idx} item xs={12} sm={6} md={control.colSize} id={`${control.type}-${id}`} style={{ padding: control.type == 'panel' || control.type == 'gridpanel' || control.type == 'tabpanel' ? 0 : '5px' }}>
                                {control.selected && renderComponent(control, idx, id)}
                            </Grid>
                        }
                    </Fragment>
                ))}
            </Grid>
        </div>
    );
};